export const USER_STORAGE_KEYS = Object.freeze({
  AUTH_SESSION: "lineup_user",
});

// Device-scoped, deliberately NOT cleared by clearUserStorage() below.
export const DEVICE_STORAGE_KEYS = Object.freeze({
  COOKIE_CONSENT: "consent-granted",
  // Privacy Mode's on/off switch. It belongs to the device, not to the account: it describes a
  // situation ("someone is looking at this screen"), not a preference. Keeping it out of
  // `user.settings` is also what stops the twenty writers of that shared blob from overwriting
  // it — see helpers/hideData.js. The classes and the treatment DO live in settings and
  // do sync across devices.
  PRIVACY_MODE: "privacy-mode",
});

export const clearUserStorage = () => {
  Object.values(USER_STORAGE_KEYS).forEach((key) => {
    localStorage.removeItem(key);
    sessionStorage.removeItem(key);
  });
};
